import { withRedirectUnauthorized } from '../../feature/authority/utils/withAuthority';
import AccountLogList from '../../components/settings/accountLog/AccountLogList';

const SettingsAccountLogPage = () => {
  return <AccountLogList />;
};

export default withRedirectUnauthorized('administratorManagement', SettingsAccountLogPage);
